import type { PropsWithChildren } from "react"
import React from "react"

import { WishlistButton } from "packages/ui-shared/components/WishlistButton/WishlistButton"

import type { ProductCardDataType } from "./types"

export interface ProductCardWishlistProps extends PropsWithChildren {
  onToggle: (productCardData: ProductCardDataType) => void
  product: ProductCardDataType
}

export const ProductCardWishlist: React.FC<ProductCardWishlistProps> = ({
  children,
  onToggle,
  product,
}) => {
  return (
    <WishlistButton
      active={product.inWishlist}
      onClick={() => onToggle(product)}
    >
      {children}
    </WishlistButton>
  )
}
